// Module
var code = "<a if-permitted=\"item.permissions\" ng-click=\"action()\" id=\"tab-done-link-large-screen\" class=\"tab-done-link waves-effect waves-blue {{item.itemClass}}\"> <i class=\"{{item.icon}}\"></i>{{item.name}} </a> ";
// Exports
export default code;